<form [formGroup]="settingsForm">
  <div class="inactive-telematic-form-container">
    <div class="flex flex-column gap-2">
      <osp-form-field>
        <osp-label [tooltip]="settingsLimitExplanation">{{ settingsLimitLabel }}</osp-label>
        <osp-input-text
          [formControlName]="controlNames.SETTINGS_LIMIT"
          [keyFilter]="REGEX_POSITIVE_INTEGER_NOT_STARTING_WITH_ZERO"
        />
        <osp-error
          [messages]="{
            required: 'shared.validation.requiredField' | translate,
            min: 'shared.validation.number.notNegative' | translate
          }"
        />
      </osp-form-field>
    </div>

    <div class="flex flex-column gap-2">
      <osp-form-field>
        <osp-label>{{ settingsLimitUnitLabel }}</osp-label>
        <osp-dropdown [formControlName]="controlNames.SETTINGS_LIMIT_UNIT" [options]="intervalDurations" />
        <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
      </osp-form-field>
    </div>

    <div class="flex flex-column gap-2">
      <osp-form-field>
        <osp-label>{{ settingsTelematicsSelectorLabel }}</osp-label>
        <osp-dropdown [formControlName]="controlNames.SETTINGS_TELEMATICS_SELECTOR" [options]="telematicsSelectors" />
        <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
      </osp-form-field>
    </div>
  </div>

  @if (allowSelectTelematicUnits()) {
    <div class="flex flex-column gap-2 col-4">
      <osp-form-field>
        <osp-label>{{ settingsTelematicsTypesLabel }}</osp-label>
        <osp-select [formControlName]="controlNames.SETTINGS_TELEMATICS_TYPES" [options]="telematicsUnitTypes" />
        <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
      </osp-form-field>
    </div>
  }
</form>
